export default {
  namespaced: true,
  access_devices: {
    title: "Dispositivos de acesso",
    name: "nome",
    serial_number: "número de série",
    mac_address: "endereço mac",
    model: "modelo",
    synchronize:"sincronizar",
    iot_id: "IOT ID"
  },
};
